import { Fragment } from "react";
import { FaRegUser } from "react-icons/fa6";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Grid, IconButton, Tooltip } from "@mui/material";

import pages from "../../../constants/pages";
import { Chip, Search, TextAvatar } from "../../../components";
import MuiTable from "../../../components/MuiTable";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple};
  color: ${colors.purple};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  border-radius: 10px;
  &:hover {
    border: 1px solid ${colors.purple};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  usersData,
  loading,
  setPage,
  setSearchKey,
  filterBy,
  setFilterBy,
}) {
  const navigate = useNavigate();

  var columns = [
    {
      name: "",
      label: "",
    },

    {
      name: "given_name",
      label: "User Name",
    },

    {
      name: "brand_user_role",
      label: "Role",
    },

    {
      name: "email",
      label: "Email",
    },

    {
      name: "account_status",
      label: "Status",
    },

    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "") {
      return (
        <TextAvatar
          size={{
            height: "50px",
            width: "50px",
            fontSize: "20px",
          }}
          borderRadius={"50%"}
          userName={row.given_name}
        />
      );
    }

    if (col.name === "account_status") {
      let label;
      let background;
      if (value === 0) {
        label = "unverified";
        background = colors.yellow;
      }

      if (value === 1) {
        label = "Accepted";
        background = colors.green;
      }

      if (value === 2 || value === 3 || value === 4 || value === 5) {
        label =
          value === 2
            ? "Blocked"
            : value === 3
            ? "Rejected"
            : value === 4
            ? "Suspended"
            : "Deleted";

        background = colors.red;
      }

      return <Chip label={label} background={background} />;
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip
            title="Manage user"
            onClick={() => navigate(pages.userDetails.route + row.user_id)}
          >
            <Icon>
              <FaRegUser style={{ height: "20px", width: "20px" }} />
            </Icon>
          </Tooltip>
        </div>
      );
    }

    return value; // default
  };

  return (
    <Fragment>
      <Grid container spacing={8}>
        <Grid size={12} />
        <Grid size={12}>
          <MuiTable
            loading={loading}
            components={[
              <ToolBar
                setPage={setPage}
                setSearchKey={setSearchKey}
                setFilterBy={setFilterBy}
                filterBy={filterBy}
              />,
            ]}
            columns={columns}
            renderCell={renderCell}
            data={usersData.users}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

export function ToolBar({ setPage, setSearchKey, filterBy, setFilterBy }) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />
      </div>
    </div>
  );
}
